// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-video-fullscreen-player {
  position: fixed;
  inset: 0;
  /* Above nested exercise-results sheets (10050) and session media dialogs. */
  z-index: 16000;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: review-fs-in 0.32s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.review-video-fullscreen-player.is-leaving {
  animation: review-fs-out 0.26s cubic-bezier(0.4, 0, 1, 1) both;
  pointer-events: none;
}

.review-video-fullscreen-player .review-video-player--fullscreen {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.review-video-fullscreen-player__video {
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 100vh;
  object-fit: contain;
  background: #000;
  transform-origin: center center;
}

.review-video-fullscreen-player__close {
  position: absolute;
  top: max(12px, env(safe-area-inset-top, 0px));
  right: max(12px, env(safe-area-inset-right, 0px));
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.42);
  color: #fff;
  cursor: pointer;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease, transform 0.15s ease;
}

.review-video-fullscreen-player__close:hover {
  background: rgba(0, 0, 0, 0.58);
}

.review-video-fullscreen-player__close:active {
  transform: scale(0.96);
}

@keyframes review-fs-in {
  from {
    opacity: 0;
    transform: scale(0.965);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes review-fs-out {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.98);
  }
}

@media (prefers-reduced-motion: reduce) {
  .review-video-fullscreen-player,
  .review-video-fullscreen-player.is-leaving {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ReviewVideoFullscreenPlayer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,4EAA4E;EAC5E,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iEAAiE;AACnE;;AAEA;EACE,8DAA8D;EAC9D,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,iDAAiD;EACjD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,wCAAwC;EACxC,uDAAuD;AACzD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".review-video-fullscreen-player {\n  position: fixed;\n  inset: 0;\n  /* Above nested exercise-results sheets (10050) and session media dialogs. */\n  z-index: 16000;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: review-fs-in 0.32s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.review-video-fullscreen-player.is-leaving {\n  animation: review-fs-out 0.26s cubic-bezier(0.4, 0, 1, 1) both;\n  pointer-events: none;\n}\n\n.review-video-fullscreen-player .review-video-player--fullscreen {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.review-video-fullscreen-player__video {\n  width: 100%;\n  height: 100%;\n  max-width: 100vw;\n  max-height: 100vh;\n  object-fit: contain;\n  background: #000;\n  transform-origin: center center;\n}\n\n.review-video-fullscreen-player__close {\n  position: absolute;\n  top: max(12px, env(safe-area-inset-top, 0px));\n  right: max(12px, env(safe-area-inset-right, 0px));\n  z-index: 40;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.42);\n  color: #fff;\n  cursor: pointer;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  -webkit-tap-highlight-color: transparent;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.review-video-fullscreen-player__close:hover {\n  background: rgba(0, 0, 0, 0.58);\n}\n\n.review-video-fullscreen-player__close:active {\n  transform: scale(0.96);\n}\n\n@keyframes review-fs-in {\n  from {\n    opacity: 0;\n    transform: scale(0.965);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes review-fs-out {\n  from {\n    opacity: 1;\n    transform: scale(1);\n  }\n  to {\n    opacity: 0;\n    transform: scale(0.98);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .review-video-fullscreen-player,\n  .review-video-fullscreen-player.is-leaving {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
